import { ButtonComponent } from '@modules/button/components/button/button.component';
import { ChipComponent } from '@modules/chip/components/chip/chip.component';
import { CardComponent } from '@modules/card/components/card/card.component';
import { CardActionsComponent } from '@modules/card/components/card-actions/card-actions.component';
import { CardHeaderComponent } from '@modules/card/components/card-header/card-header.component';
import { CheckboxComponent } from '@modules/checkbox/components/checkbox/checkbox.component';
import { FooterComponent } from '@modules/footer/footer.component';
import { InputComponent } from '@modules/input/components/input/input.component';
import { MenuComponent } from '@modules/menu/menu.component';
import { SelectComponent } from '@modules/select/components/select/select.component';
import { TabComponent } from '@modules/tab/components/tab/tab.component';
import { TextareaComponent } from '@modules/textarea/components/textarea/textarea.component';
import { AppComponent } from '@app/app.component';
import { TextComponent } from '@modules/text/components/text/text.component';
import { SidenavComponent } from '@app/modules/sidenav/components/sidenav/sidenav.component';
import { SidenavItemComponent } from '@modules/sidenav/components/sidenav-item/sidenav-item.component';
import { AvatarComponent } from '@modules/avatar/avatar/avatar.component';
import { NavbarComponent } from '@modules/navbar/components/navbar/navbar.component';
import { DropdownButtonComponent } from '@modules/dropdown-button/components/dropdown-button/dropdown-button.component';
import { CardContentComponent } from '@modules/card/components/card-content/card-content.component';
import { HeaderComponent } from '@modules/header/components/header/header.component';
import { PaginationComponent } from '@modules/pagination/components/pagination/pagination.component';
import { PasswordLevelComponent } from '@modules/password-level/components/password-level/password-level.component';
import { LoadComponent } from '@modules/load-micro/components/load/load.component';
import { ExpansionPanelComponent } from '@modules/expansion-panel/components/expansion-panel/expansion-panel.component';
import { ModalComponent } from '@modules/modal/components/modal/modal.component';
import { RequiredMessageComponent } from '@app/modules/required-message/components/required-message/required-message.component';
import { RadioButtonComponent } from '@modules/radio-button/components/radio-button/radio-button.component';
import { IconComponent } from '@modules/icon/components/icon/icon.component';
import { PasswordSecurityComponent } from '@modules/password-security/components/password-security/password-security.component';
import { FooterInfoComponent } from '@app/modules/footer/components/footer-info/footer-info.component';
import { BreadcrumbComponent } from '../../modules/breadcrumb/components/breadcrumb/breadcrumb.component';
import { SwitchComponent } from '@app/modules/switch/component/switch.component';
import { TabSimpleComponent } from '@app/modules/tab/components/tab-simple/tab-simple.component';

export const GetListComponent = [
  { name: 'vdc-micro-designguide', component: AppComponent },
  { name: 'vdc-component-button', component: ButtonComponent },
  { name: 'vdc-component-card', component: CardComponent },
  { name: 'vdc-component-card-actions', component: CardActionsComponent },
  { name: 'vdc-component-card-header', component: CardHeaderComponent },
  { name: 'vdc-component-card-content', component: CardContentComponent },
  { name: 'vdc-component-checkbox', component: CheckboxComponent },
  { name: 'vdc-component-chip', component: ChipComponent },
  { name: 'vdc-component-footer', component: FooterComponent },
  { name: 'vdc-component-input', component: InputComponent },
  { name: 'vdc-component-menu', component: MenuComponent },
  { name: 'vdc-component-select', component: SelectComponent },
  { name: 'vdc-component-tab', component: TabComponent },
  { name: 'vdc-component-tab-simple', component: TabSimpleComponent },
  { name: 'vdc-component-text', component: TextComponent },
  { name: 'vdc-component-textarea', component: TextareaComponent },
  { name: 'vdc-component-avatar', component: AvatarComponent },
  { name: 'vdc-component-navbar', component: NavbarComponent },
  { name: 'vdc-component-dropdown-button', component: DropdownButtonComponent },
  { name: 'vdc-component-sidenav', component: SidenavComponent },
  { name: 'vdc-component-sidenav-item', component: SidenavItemComponent },
  { name: 'vdc-component-header', component: HeaderComponent },
  { name: 'vdc-component-pagination', component: PaginationComponent },
  { name: 'vdc-component-password-level', component: PasswordLevelComponent },
  { name: 'vdc-load-micro', component: LoadComponent },
  { name: 'vdc-component-expansion-panel', component: ExpansionPanelComponent },
  { name: 'vdc-component-modal', component: ModalComponent },
  { name: 'vdc-required-message', component: RequiredMessageComponent },
  { name: 'vdc-radio-button', component: RadioButtonComponent },
  { name: 'vdc-component-icon', component: IconComponent },
  { name: 'vdc-component-footer-info', component: FooterInfoComponent },
  { name: 'vdc-component-breadcrumb', component: BreadcrumbComponent },
  { name: 'vdc-component-switch', component: SwitchComponent },
  {
    name: 'vdc-component-password-security',
    component: PasswordSecurityComponent,
  },
];

export const entryComponents = GetListComponent.map(
  (component) => component.component
);
